import React from "react";

const Comparison = () => {

    return(
        <section className="py-5 text-white" style={{ background: 'linear-gradient(to right, #38C6C3,rgb(56, 198, 153))' }}>
            <div className="container">
                <h2 className="text-center mb-4 fw-bold text-uppercase">Fibre vs LTE / ADSL</h2>
                <p className="text-center mb-5">
                Understand the advantages of Fibre for your business over traditional internet solutions.
                </p>

                {/* HEADINGS */}
                <div className="row fw-bold border-bottom border-white text-center pb-2">
                <div className="col-4">Feature</div>
                <div className="col-4">Fibre</div>
                <div className="col-4">LTE / ADSL</div>
                </div>

                {/* Data Rows */}
                {[
                ["Speed", "Up to 1000 Mbps", "Up to 40 Mbps"],
                ["Reliability", "Highly Stable", "Affected by Weather & Signal"],
                ["Latency", "Low (Good for VoIP & Video)", "Higher Latency"],
                ["Data Caps", "Uncapped", "Often Capped or Throttled"],
                ["Business Suitability", "Designed for Heavy Business Use", "Basic Browsing / Backup Option"],
                ].map(([feature, fibre, lte], index) => (
                <div
                    className="row text-center border-bottom border-white py-3"
                    key={index}
                    style={{ fontSize: '0.95rem' }}
                >
                    <div className="col-4">{feature}</div>
                    <div className="col-4">{fibre}</div>
                    <div className="col-4">{lte}</div>
                </div>
                ))}

                <div className="text-center mt-5">
                <p className="fs-5 fw-semibold">
                    Fibre is the smart long-term investment for businesses aiming to scale efficiently.
                </p>
                <a href="#Packages" className="btn px-5 py-2 rounded-pill mt-2 text-white fw-bold" style={{backgroundColor:'#0f174f'}}>
                    Explore Business Packages
                </a>
                </div>
            </div>
            </section>
    );
};

export default Comparison;